import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const Dialog = props => (
  <div className="Dialog" data-testid={props['data-testid']}>
    <h1 className="title">{props.title}</h1>
    {props.subtitle !== null && <p className="subtitle">{props.subtitle}</p>}
    {
      props.supplementaryText && (
        <p className="supplementary-text">{props.supplementaryText}</p>
      )
    }
    <style jsx>{styles}</style>
  </div>
)

Dialog.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  supplementaryText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  'data-testid': PropTypes.string,
}

Dialog.defaultProps = {
  title: '',
  subtitle: '',
  supplementaryText: '',
  'data-testid': 'dialog', // Default test id
}

export default Dialog
